import React, {useContext} from "react";
import Lottie from "lottie-react";
import audioWaveDark from "../../../../../../assets/audioWaveDark.svg";
import audioWavePlayingDark from "../../../../../../assets/audioWavePlayingDark.json";
import {MessageContext} from "../../../Message.tsx";

interface PlayAudioProps {
    isPlaying: boolean;
    handleAudioClickHelper: any;
    isInProgress: boolean;
}

const PlayAudio: React.FC<PlayAudioProps> = ({ isPlaying, handleAudioClickHelper, isInProgress }) => {
    const { isPreview } = useContext(MessageContext);

    return (
        <button
            className={`invert-0 dark:invert brightness-[0.97] dark:brightness-[0.91] w-5 h-5 ${isInProgress || isPreview ? 'opacity-50 cursor-default' : 'cursor-pointer'}`}
            onClick={isInProgress || isPreview ? undefined : handleAudioClickHelper}
            disabled={isInProgress || isPreview}
            data-tooltip-id="main-tooltip"
            data-tooltip-content={"Play audio"}
            data-tooltip-place="top"
        >
            {isPlaying ? (
                <Lottie
                    animationData={audioWavePlayingDark}
                    loop={true}
                    style={{ width: 20, height: 20 }}
                />
            ) : (
                <img
                    src={`${audioWaveDark}`}
                    alt="PlayAudio"
                    className={isInProgress || isPreview ? 'filter grayscale' : ''}
                />
            )}
        </button>
    );
}

export default PlayAudio;
